import { videoFormat } from 'utils'

import { useBrandTheme } from 'services/Branding/hooks'
import { t } from 'services/Translation'
import { testProps } from 'utils/test/qaData'

import { Tooltip } from 'components/uiKit/Dropdown'

import { ItemDivStyled, ItemTimeSpanStyled, ItemTitleSpanStyled } from './styled'

interface IPlaybackRateProps {
  time: number
  title: string
  disabled?: boolean
}

const Item: React.FC<IPlaybackRateProps> = ({ time, title, disabled }) => {
  const theme = useBrandTheme()

  const content = (
    <ItemDivStyled $disabled={disabled} $theme={theme}>
      <ItemTimeSpanStyled {...testProps({ el: 'timeItem', value: videoFormat(time) })}>
        {videoFormat(time)}
      </ItemTimeSpanStyled>
      <ItemTitleSpanStyled {...testProps({ el: 'titleItem', value: title })}>
        {title}
      </ItemTitleSpanStyled>
    </ItemDivStyled>
  )

  if (disabled) {
    return <Tooltip overlay={t('elements.media.seekingDisabled')}>{content}</Tooltip>
  }

  return content
}

export default Item
